"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var extractTargetUnit = function extractTargetUnit(_ref) {
  var _ref$measurementSyste = _ref.measurementSystem,
      measurementSystem = _ref$measurementSyste === void 0 ? 'metric' : _ref$measurementSyste,
      _ref$unit = _ref.unit,
      unit = _ref$unit === void 0 ? '' : _ref$unit,
      _ref$sport = _ref.sport,
      sport = _ref$sport === void 0 ? '' : _ref$sport;

  if (sport === 'Swimming') {
    return measurementSystem === 'imperial' ? 'yards' : 'meters';
  }

  if (unit === 'climb' || unit === 'descent') {
    return measurementSystem === 'imperial' ? 'feet' : 'meters';
  }

  return measurementSystem === 'imperial' ? 'miles' : 'km';
};

var _default = extractTargetUnit;
exports["default"] = _default;
//# sourceMappingURL=extractTargetUnit.js.map